<template>
  <layout-content>
    <v-btn
      slot="top-buttons"
      class="top-buttons"
      fab
      dark
      small
      color="#394858"
      @click="make_import"
    >
      <v-icon dark> mdi-plus </v-icon>
    </v-btn>
    <vuex-table :fields="fields" table_store="import_files/table">
      <template #action="{ item }">
        <tooltip
          :content="$t('shared.download_file')"
          theme="light"
          :transfer="true"
          placement="top"
          class="text-left tooltip-import"
        >
          <table-control type="download" @click="download(item)" />
        </tooltip>

        <tooltip
          :content="$t('shared.import_edit')"
          theme="light"
          :transfer="true"
          placement="top"
          class="text-left tooltip-import"
        >
          <table-control v-if="item.state == 'draft'" type="edit" @click="edit(item)" />
        </tooltip>
      </template>
    </vuex-table>
  </layout-content>
</template>

<script>
  import { ProjectModalService } from '@projects/modals/ProjectModalService';
  import { ImportService } from '@projects/services/ImportService';
  import { TasksService } from '@tasks/services/TasksService';

  export default {
    data: () => ({
    }),

    computed: {
      fields() {
        return [
          {
            key: 'id',
            label: this.$t('projects.import.table.field.id'),
            thStyle: { width: '50px' }
          },
          {
            key: 'name',
            label: this.$t('projects.import.table.field.file_name')
          },
          {
            key: 'created_at',
            label: this.$t('projects.import.table.field.created_at'),
            thStyle: { width: '200px' }
          },
          {
            key: 'state',
            label: this.$t('projects.import.table.field.status.title'),
            thStyle: { width: '200px' },
            formatter: (value) => this.$t(`projects.import.table.field.status.${value}`)
          },
          {
            key: 'rows',
            label: this.$t('projects.import.table.field.added'),
            thStyle: { width: '200px' }
          },
          {
            key: 'action',
            label: this.$t('projects.import.table.field.actions'),
            thStyle: { width: '200px' },
            class: 'text-right'
          }
        ];
      }
    },

    created() {
      // this.get_import_files();
    },

    methods: {
      get_import_files() {
        ImportService.getList(this.$route.params.id)
          .then((resp) => {
            const files = resp.data;
            const project_id = this.$route.params.id;
            files.forEach((file) => {
              if (file.project_id === project_id) {
                this.csv_files.push(file);
              }
            });
          })
          .catch((error) => {
            this.$noty.server_error(error);
          });
      },
      make_import() {
        ProjectModalService.make_import(this.database_id, this.token);
      },

      edit(item) {
        this.$router.push({
          name: 'projects.import.edit',
          params: {
            project_id: this.$route.params.id,
            file_id: item.id,
            file_name: item.name
          }
        });
      },

      download(item) {
        TasksService.downloadFile(this.$route.params.id, item.id).then((resp) => {
          const filename = item.name;
          let blob = new Blob([resp]);
          let link = document.createElement('a');
          link.href = window.URL.createObjectURL(blob);
          link.download = filename;
          link.click();
        });
      }
    }
  };
</script>

<style lang="scss">
  .tooltip-import {
    position: relative;
    .ivu-tooltip-content {
      width: 100%;
    }
    &:nth-child(1) {
      .ivu-tooltip-content {
        min-width: 112px;
      }
    }
    &:nth-child(2) {
      .ivu-tooltip-content {
        min-width: 174px;
      }
    }
  }
</style>
